import { Stack, Typography } from '@mui/material';
import { IFamilyMembers } from 'API/personalDetails';
import { compareDesc } from 'date-fns';
import { useIsDesktop } from 'Hooks';
import { FamilyCard } from '../FamilyCard';

interface Props {
  title: string;
  children: IFamilyMembers[];
}

export const ChildrenInfo = ({ title, children }: Props) => {
  const isDesktop = useIsDesktop();

  children.sort((a: IFamilyMembers, b: IFamilyMembers) =>
    compareDesc(new Date(b.birthDate), new Date(a.birthDate))
  );

  return (
    <Stack gap={'16px'}>
      <Typography variant={'body6'} component='h3'>
        {title}
      </Typography>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        justifyContent='flex-start'
        flexWrap='wrap'
        marginBottom='15px'
        gap={'24px'}
      >
        {children?.map((child: IFamilyMembers, index: number) => {
          return (
            <Stack
              width={isDesktop ? '210px' : '100%'}
              key={child.idNumber + index}
            >
              <FamilyCard familyMember={child} />
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};
